import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgForm, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-delivery-details',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatRadioModule, MatSelectModule],
  templateUrl: './delivery-details.component.html',
  styleUrls: ['./delivery-details.component.scss']
})
export class DeliveryDetailsComponent implements OnInit {
  
  @ViewChild('orderDeliveryDetailsNgForm') orderDeliveryDetailsNgForm: NgForm;

  @Input() isScreenSmall: boolean = false;

  @Output() confirmDeliveryOrderEvent = new EventEmitter<any>();

  public orderDeliveryDetailsForm: UntypedFormGroup;

  public ResidenceType: string = 'FreeStanding';

  public provinces: string[] = [
    'Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal',
    'Limpopo', 'Mpumalanga', 'Northern Cape', 'North West', 'Western Cape'
  ];
  public selectedProvince: string = '';



   /**
     * Constructor
     */
   constructor(
    private _formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    
    this.orderDeliveryDetailsForm = this._formBuilder.group({
      DeliveryAddressPropertyType: this.ResidenceType,
      DeliveryCity: [''],
      DeliveryComplexName: [''],
      DeliveryCountry: ['South Africa'],
      DeliveryPostalCode: [''],
      DeliveryStreetName: [''],
      DeliveryStreetNumber: [''],
      DeliveryFloorNumber: [''],
      DeliveryComplexStreetName: [''],
      DeliverySubComplexName: [''],
      DeliverySuburb: [''],
      DeliveryTown: [''],
      DeliveryTownSuburb: [''],
      DeliveryUnitNumber: [''],
      DeliveryErfNumber: [''],
      DeliveryBlockName: [''],
      LeadNotes: ['']

    })

    this.residenceType();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  public residenceType(event?: any) {

    this.orderDeliveryDetailsForm.reset();
    
    if (event) { 
      this.ResidenceType = event.value;
    } else {
      this.ResidenceType = this.ResidenceType
    }

    this.isFormValid(false);

    // Look at a better solution surely ........
    this.orderDeliveryDetailsForm.get('DeliveryStreetNumber').clearValidators();
    this.orderDeliveryDetailsForm.get('DeliveryStreetName').clearValidators();
    this.orderDeliveryDetailsForm.get('DeliveryTown').clearValidators();
    this.orderDeliveryDetailsForm.get('DeliveryCity').clearValidators();
    this.orderDeliveryDetailsForm.get('DeliveryPostalCode').clearValidators();
    this.orderDeliveryDetailsForm.get('DeliveryUnitNumber').clearValidators();
    this.orderDeliveryDetailsForm.get('DeliveryComplexName').clearValidators();
    this.orderDeliveryDetailsForm.get('DeliveryComplexStreetName').clearValidators();
    this.orderDeliveryDetailsForm.get('DeliverySubComplexName').clearValidators();
    this.orderDeliveryDetailsForm.get('DeliveryErfNumber').clearValidators();
    this.orderDeliveryDetailsForm.get('LeadNotes').clearValidators();
    this.orderDeliveryDetailsForm.get('DeliveryFloorNumber').clearValidators();
    this.orderDeliveryDetailsForm.get('DeliveryBlockName').clearValidators();


    if (this.ResidenceType == 'FreeStanding') {
      this.orderDeliveryDetailsForm.get('DeliveryStreetNumber').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryStreetNumber').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryStreetName').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryStreetName').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryTown').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryTown').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryCity').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryCity').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryPostalCode').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryPostalCode').updateValueAndValidity();
    } else if (this.ResidenceType == 'Estate') {
      this.orderDeliveryDetailsForm.get('DeliveryUnitNumber').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryUnitNumber').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryComplexName').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryComplexName').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryComplexStreetName').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryComplexStreetName').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliverySubComplexName').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliverySubComplexName').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryTown').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryTown').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryCity').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryCity').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryPostalCode').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryPostalCode').updateValueAndValidity();
    } else if (this.ResidenceType == 'Plot') {
      this.orderDeliveryDetailsForm.get('DeliveryErfNumber').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryErfNumber').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('LeadNotes').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('LeadNotes').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryTown').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryTown').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryCity').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryCity').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryPostalCode').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryPostalCode').updateValueAndValidity();
    } else {
      this.orderDeliveryDetailsForm.get('DeliveryStreetNumber').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryStreetNumber').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryStreetName').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryStreetName').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryUnitNumber').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryUnitNumber').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryComplexName').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryComplexName').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryFloorNumber').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryFloorNumber').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryBlockName').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryBlockName').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryComplexStreetName').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryComplexStreetName').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliverySubComplexName').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliverySubComplexName').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryTown').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryTown').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryCity').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryCity').updateValueAndValidity();

      this.orderDeliveryDetailsForm.get('DeliveryPostalCode').setValidators([Validators.required]);
      this.orderDeliveryDetailsForm.get('DeliveryPostalCode').updateValueAndValidity();
    }

  }

  // public isFormValid() {
  //   this.orderDeliveryDetailsForm.value.ResidenceType = this.ResidenceType
  //   if (this.orderDeliveryDetailsForm.valid) {
  //     this.confirmDeliveryOrderEvent.emit(this.orderDeliveryDetailsForm.value);
  //   }
  // }

  public isFormValid(val?: any) {
    this.orderDeliveryDetailsForm.value.DeliveryAddressPropertyType = this.ResidenceType

    if(val == false ) {
      this.confirmDeliveryOrderEvent.emit(null);
    } else if(this.orderDeliveryDetailsForm.valid) {
      this.confirmDeliveryOrderEvent.emit(this.orderDeliveryDetailsForm.value);
    }
  }

}
